import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AlertOPEEnum} from "./AlertOPEEnum";

class I {
  alertId!: number;
  name?: string;
}

class O {
  id!: number;
}

export class DuplicateMetricInstanceAlertCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(AlertOPEEnum.DuplicateMetricInstanceAlert);
    this.i = new I();
    this.o = new O();
  }
}
